import type {ContourMarkerItem} from '../map-marker/index.ts';
import {Gps} from "@api/types.ts";
import type {LatLng} from "@src/features";
import {Theme} from "@mui/material";

export type MapLatLng = {
    lat: number;
    lng: number;
};

export enum CourseZonePolygonType {
    GREEN = 'green',
    TEEBOX = 'teebox',
    FAIRWAY = 'fairway',
    BUNKER = 'bunker',
    BACKGROUND = 'background',
}

export type CourseContourPolygon = {
    id: string;
    courseId: string;
    polygonId?: string;
    holeNumber?: number;
    contour: MapLatLng[];
};

export type CourseZonePolygon = {
    id: string;
    courseId: string;
    polygonId?: string;
    holeNumber?: number;
    type: CourseZonePolygonType;
    contour: MapLatLng[];
};

export type CourseMapData = {
    courseId: string;
    courseName: string;
    sourceFileName: string;
    holesCount: number;
    defaultCenter: MapLatLng;
    contours: CourseContourPolygon[];
    zonePolygons: CourseZonePolygon[];
    markers: ContourMarkerItem[];
};
export type Contour = LatLng[];

export type BoundsBox = {
    minLat: number;
    maxLat: number;
    minLng: number;
    maxLng: number;
};

export type IndexedContour = {
    id: string;
    polygon: CourseContourPolygon;
    bounds: BoundsBox;
};

export type IndexedZonePolygon = {
    id: string;
    polygon: CourseZonePolygon;
    bounds: BoundsBox;
};

export type MapSize = {
    width: number;
    height: number;
};

export type FitLockCamera = {
    center: LatLng;
    zoom: number;
    minZoom: number;
    maxZoom?: number;
    restriction: google.maps.MapRestriction;
};

export type MarkerDropResultPayload = {
    marker: ContourMarkerItem;
    from: LatLng;
    droppedAt: LatLng | null;
    finalPosition: LatLng;
    droppedInsidePolygon: boolean;
};

export type MarkerPositionChangePayload = {
    marker: ContourMarkerItem;
    from: LatLng;
    to: LatLng;
};

export type ContoursMapPolygonPayload = {
    polygonId: string;
    holeNumber?: number;
    polygon: CourseContourPolygon | CourseZonePolygon;
};

export type ContoursMapViewportBehavior = 'free' | 'fit-and-lock';

export type ContoursMapCamera = {
    center: LatLng;
    zoom: number;
    revision?: number | string;
};

export type WorldPoint = {
    x: number;
    y: number;
};


export type ContoursMapPalette = Theme['palette'];
